module.exports = __webpack_public_path__ + "bb.svg?fe3ac3fea6f1abd9cfce0635cc6d610b";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/bb.svg
// module id = 989
// module chunks = 0